export default __webpack_public_path__ + "static/divisaMoney-37298e6334ff1ad22b07657869809cb2.svg";